// @flow
import React from 'react';
import glamorous, { Span } from 'glamorous';
import Glyph from 'app/components/commons/Glyph';
import t from 'app/utils/translate';

const TrainingChallengeNoticeDiv = glamorous.div(props => ({
  color: props.theme.color.white,
  height: 100,
  backgroundColor: props.theme.color.basis2,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '10px 10px 0 0',
  textAlign: 'center',
  paddingLeft: props.theme.spacing.small,
  paddingRight: props.theme.spacing.small,
}));

const BigText = glamorous.div(props => ({
  color: props.theme.color.primary,
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
}));

const SmallText = glamorous.span(props => ({
  color: props.theme.color.white,
  fontSize: props.theme.fontSize.xsmall,
}));

const Red = glamorous.span({
  color: 'red',
});

export default function TrainingChallengeNotice() {
  return (
    <TrainingChallengeNoticeDiv>
      <BigText>
        <Span paddingRight={10}>
          {t('Training Challenge: Learn the rules. Pick a team. Watch the live leaderboard in fast forward!')}
        </Span>
        <Glyph icon="ios-fastforward" />
      </BigText>
      <SmallText>
        <Red>*</Red>
        {t('This is a practice facility only. You will not win any prize money inside the Training Ground.')}
      </SmallText>
    </TrainingChallengeNoticeDiv>
  );
}
